import {SearchUrlService} from 'plugins/modules/search/services/SearchUrlService';
import {SEARCH_ROUTE} from 'routing/constants';

export const getPopularRequestUrl = (value: string) => {
    return `${SEARCH_ROUTE}?${SearchUrlService.COMMON_PARAM_NAMES.QUERY}=${value}`;
};
